import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7862198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-container" }
const _hoisted_2 = { class: "item-card-box" }
const _hoisted_3 = { class: "item-card-title-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-card-title-left" }, "我的订单", -1))
const _hoisted_5 = { class: "item-card-title-right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看全部订单", -1))
const _hoisted_7 = { class: "user-order-menu-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_ui_icon, {
            class: "icon-box",
            modelValue: "iconiconfontjiantou2"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createVNode(_component_ui_icon, {
              class: "icon-box",
              modelValue: item.icon
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", null, _toDisplayString(item.name), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}